import React, { useMemo, useRef } from 'react';
import { Editor as TinyMCEEditor } from '@tinymce/tinymce-react';
import type { Editor as TinyMCEEditorType } from 'tinymce';
import type { InitOptions } from '@tinymce/tinymce-react/lib/cjs/main/ts/components/Editor';
import { EditorConfigBuilder } from './config/ConfigBuilder';
import type { IEditorConfigOptions } from './config/ConfigBuilder';
import './tinymce-theme-override.css';

interface IProps {
  config?: IEditorConfigOptions;
  value: string;
  disabled?: boolean;
  onChange: (value: string) => void;
  onEditorInit?: (editor: TinyMCEEditorType) => void;
}

const Editor: React.FC<IProps> = ({
  value,
  disabled,
  config,
  onChange,
  onEditorInit,
}) => {
  const editorRef = useRef<TinyMCEEditorType | null>(null);

  const configuration = useMemo(
    () => new EditorConfigBuilder(config).build(),
    [config]
  );

  const handleEditorChange = (content: string) => {
    onChange(content);
  };

  return (
    <TinyMCEEditor
      licenseKey="gpl"
      tinymceScriptSrc="/tinymce/tinymce.min.js"
      value={value}
      onEditorChange={handleEditorChange}
      disabled={disabled}
      init={
        {
          ...configuration,
          setup: (editor: TinyMCEEditorType) => {
            editorRef.current = editor;
            if (onEditorInit) {
              onEditorInit(editor);
            }
          },
        } as InitOptions
      }
    />
  );
};

export default Editor;
